export const getFeaturedTileLayout = (index: number): 'portrait' | 'square' => {
    const array = [0, 3];
    return array.includes(index % 4) ? 'portrait' : 'square';
};

export const getResultTileLayout = (index: number): 'portrait' | 'square' => {
    const array = [0, 2, 5, 7];
    return array.includes(index % 8) ? 'portrait' : 'square';
};

export const getResultTileLayoutMobile = (
    index: number
): 'portrait' | 'square' => {
    return index % 2 === 0 ? 'portrait' : 'square';
};
